import { Component, inject, OnDestroy, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { ConfigSistemaService } from "src/app/core/services/behavior/config-sistema.service";
import { ImpressaoBehaviorService } from "src/app/core/services/behavior/impressaoBehavior.service";
import { StorageService } from "src/app/core/services/behavior/storage.service";
import { AuthenticationService } from "src/app/core/services/http/authentication.service";
import { ImpressaoService } from "src/app/core/services/http/impressao.service";
import { SistemaService } from "src/app/core/services/http/sistema.service";
import { NomeGrupoDilaog } from "src/app/shared/components/nome-grupo-dialog/nome-grupo-dialog.component";
import { Computadores as Computador } from "src/app/shared/models/computadores.model";
import { ConfigPdvDeliveryRequest, ConfigPdvDeliveryResponse } from "src/app/shared/models/configuracao.model";
import { FamiliaImpressaoRequest, ImpressaoDet, ImpressaoGrupoRequest, GrupoImpressaoResponse, ImpressoraConfig } from "src/app/shared/models/impressora-config.model";
import { ProdutoFamiliaCheckboxViewModel, ProdutoFamiliaModel } from "src/app/shared/models/produto-familia.model";
import { CastModelUtils } from "src/app/shared/utils/CastModelUtils";

@Component({
    selector: 'app-configuracao-impressao',
    templateUrl: './configuracao-impressao.page.html',
    styleUrls: ['./configuracao-impressao.page.scss'],
})
export class ConfiguracaoImpressaoComponent implements OnInit, OnDestroy {
    public configs: ConfigPdvDeliveryResponse = new ConfigPdvDeliveryResponse();
    readonly dialog = inject(MatDialog);

    private subs: Subscription[] = [];

    public codigoComputadorSel: number = 0;
    public computadores: Computador[] = [];
    public impressorasDisponiveis: string[] = [];
    public gruposImpressaoCodigoSel: number = -1;
    public gruposImpressoesFiltradas: GrupoImpressaoResponse[] = [];
    public gruposImpressoes: GrupoImpressaoResponse[] = [];
    public impressoraConfiSel: GrupoImpressaoResponse = new GrupoImpressaoResponse();
    public termo: string = '';
    public produtosFamilias: ProdutoFamiliaCheckboxViewModel[] = [];
    public produtosFamiliasFiltrados: ProdutoFamiliaCheckboxViewModel[] = [];
    public erro: ErroComputadores = new ErroComputadores(false);
    public reqConfigEmAndamento: boolean = false;
    public unicoImprimirPrecontasCelular: boolean = false;

    constructor(
        private storageService: StorageService,
        private authService: AuthenticationService,
        private impressaoService: ImpressaoService,
        private impressaoBehaviorService: ImpressaoBehaviorService,
        private configSistemaService: ConfigSistemaService,
        private sistemaService: SistemaService,
    ) { }

    ngOnInit() {
        const sub = this.authService.isAuthenticated.subscribe((autenticado) => {
            if (!autenticado) return;

            this.recuperarComputadores();
            this.carregarImpressoraGrupos();
            this.carregarFamilias();
            this.recuperarConfig();
        });

        this.subs.push(sub);
    }

    ngOnDestroy() {
        this.subs.forEach((sub) => {
            sub.unsubscribe();
        });
    }

    public recuperarConfig() {
        this.configs = CastModelUtils.ClonarObjetoComPropriedadesIguais(this.configSistemaService.config, new ConfigPdvDeliveryResponse());
    }

    public async alterarConfigPedido(configPedido: ConfigPdvDeliveryResponse) {        
        const config = await this.configSistemaService.obterPedido();

        config.computadores = this.computadores;

        if (this.reqConfigEmAndamento) {
            // configPedido.unicoImprimirPrecontasCelular = config.unicoImprimirPrecontasCelular;
            return;
        }

        this.reqConfigEmAndamento = true;

        let request = CastModelUtils.ClonarObjetoComPropriedadesIguais(config, new ConfigPdvDeliveryRequest());
        
        this.sistemaService.setConfigDelivery(request).subscribe(async (res) => {
            if (!res.success) {
                this.reqConfigEmAndamento = false;
                return;
            }

            this.configSistemaService.salvarComputadores(configPedido.computadores);
            this.reqConfigEmAndamento = false;
        });
    }

    public atualizarListagemImpressora() {
        const computadorEncontrado = this.computadores.find((computador) => computador.codigoComputador === this.codigoComputadorSel);

        if (computadorEncontrado) {
            this.impressorasDisponiveis = computadorEncontrado.impressorasInstaladas;
            this.unicoImprimirPrecontasCelular = computadorEncontrado.unicoImprimirPrecontasCelular;
            this.filtrarGrupo();
        }
    }

    private async recuperarComputadores() {
        const configSaved = await this.storageService.get("configPedido");

        if (configSaved !== null) {
            const computadores = configSaved.computadores;

            if (computadores === undefined || computadores.length === 0) {
                this.erro = new ErroComputadores(true, 'Nenhum computador encontrado :/');
            }

            this.computadores = computadores;
            this.selecionarPrimeiroComputador();

            if (computadores.length === 0) {
                console.error("Computadores não encontrados!");
            }
        }
    }

    public alterarUnicoImprimirPrecontasCelular() {        
        const computador = this.computadores.find((c) => c.codigoComputador === this.codigoComputadorSel);

        if (!computador) {
            return;
        }

        this.computadores.map((c) => c.unicoImprimirPrecontasCelular = false);

        computador.unicoImprimirPrecontasCelular = this.unicoImprimirPrecontasCelular;

        this.alterarConfigPedido(this.configs);
    }

    private selecionarPrimeiroComputador() {
        if ((this.codigoComputadorSel === 0) && (this.computadores.length > 0)) {
            this.codigoComputadorSel = this.computadores[0].codigoComputador;
            this.atualizarListagemImpressora();
        }
    }

    private filtrarGrupo() {
        const impressaoFiltrado = this.gruposImpressoes.filter((g) => g.codigoComputador === this.codigoComputadorSel);
        this.gruposImpressoesFiltradas = impressaoFiltrado;

        if (this.gruposImpressoesFiltradas.length > 0) {
            this.gruposImpressaoCodigoSel = impressaoFiltrado[0].codigo;
            this.AlterarGrupoCodigoSelecionado(this.gruposImpressaoCodigoSel);
        } else {
            this.gruposImpressaoCodigoSel = 0;
            this.impressoraConfiSel = new GrupoImpressaoResponse();
        }
    }

    private async carregarImpressoraGrupos() {
        this.impressaoService.getAll().subscribe((res) => {
            if (!res.success) {
                return;
            }

            this.gruposImpressoes = res.data.map((impressora) => CastModelUtils.ClonarObjetoComPropriedadesIguais(impressora, new GrupoImpressaoResponse()));
            this.filtrarGrupo();
        });
    }

    public alterarGrupo(selectHTML: any) {
        const codigo = selectHTML.source.value;
        this.AlterarGrupoCodigoSelecionado(codigo);
    }

    private AlterarGrupoCodigoSelecionado(codigo: number) {
        const grupo = this.gruposImpressoes.find((impressora) => impressora.codigo === codigo);

        if (grupo) {
            this.impressoraConfiSel = grupo;
            this.atualizarChecksListaProdutos();
        } else {
            this.impressoraConfiSel = null;
        }
    }

    private getNomeComputador() {
        const computador = this.computadores.find((c) => c.codigoComputador === this.codigoComputadorSel);
        return computador ? computador.nomeComputador : ' # erro #';
    }

    public criarGrupo(nome: string) {
        const impressao: ImpressaoGrupoRequest = new ImpressaoGrupoRequest();
        impressao.grupo = nome;
        impressao.nomeComputador = this.getNomeComputador();

        this.impressaoService.adicionarImpressao(impressao).subscribe((res) => {
            if (!res.success) {
                return;
            }

            const impressora: GrupoImpressaoResponse = {
                codigo: res.data.codigo,
                codigoComputador: 0,
                dets: [],
                grupo: nome,
                impressora: '',
                imprimeDuasVias: false,
                modoFicha: false,
                usarModoTela: false,
            }

            this.gruposImpressoesFiltradas.push(impressora);
            this.atualizarChecksListaProdutos();
            this.pesquisar(this.termo);
        });
    }

    private atualizarChecksListaProdutos() {
        this.marcarTodosProdutosComoDesativos();

        this.impressoraConfiSel.dets.forEach((det) => {
            const familiaEncontrada = this.produtosFamilias.find((familia) => det.codFamilia === familia.codigo);

            if (familiaEncontrada) {
                familiaEncontrada.check = true;
                this.pesquisar(this.termo);
            }
        });
    }

    private marcarTodosProdutosComoDesativos() {
        this.produtosFamilias.map((familia) => familia.check = false);
    }

    private async carregarFamilias() {
        const familiasSaved = await this.impressaoBehaviorService.obterFamilia();

        let familias: ProdutoFamiliaModel[] = [];
        familias = familiasSaved.filter((familia) => familia.nome
            .toUpperCase() !== "INDEFINIDO" && familia.nome.toUpperCase() !== "SERVICOS" && familia.nome.toUpperCase() !== "COMPLEMENTO DE PEDIDO");


        this.produtosFamilias = familias.map((familia) => CastModelUtils.ClonarObjetoComPropriedadesIguais(familia, new ProdutoFamiliaCheckboxViewModel()));
        this.pesquisar(this.termo);
    }

    public pesquisar(termo: string) {
        termo = termo.toLowerCase();
        this.produtosFamiliasFiltrados = this.produtosFamilias.filter((produto) => produto.nome.toLowerCase().includes(termo));
    }

    public abrirDialogNomeGrupo() {
        const dialogRef = this.dialog.open(NomeGrupoDilaog);

        dialogRef.afterClosed().subscribe(res => {
            if (res !== undefined) {
                this.criarGrupo(res);
            }
        });
    }

    public alterarImpressaoGrupo() {
        const impressaoGrupoRequest: ImpressaoGrupoRequest = new ImpressaoGrupoRequest();

        impressaoGrupoRequest.grupo = this.impressoraConfiSel.grupo;
        impressaoGrupoRequest.impressora = this.impressoraConfiSel.impressora;
        impressaoGrupoRequest.imprimeDuasVias = this.impressoraConfiSel.imprimeDuasVias;
        impressaoGrupoRequest.modoFicha = this.impressoraConfiSel.modoFicha;
        impressaoGrupoRequest.usarModoTela = this.impressoraConfiSel.usarModoTela;
        impressaoGrupoRequest.codigo = this.impressoraConfiSel.codigo;
        impressaoGrupoRequest.nomeComputador = this.getNomeComputador();

        this.impressaoService.alterarImpressao(impressaoGrupoRequest).subscribe((res) => {
            if (!res.success) {
                return;
            }

            const impressoraEncontrada = this.gruposImpressoesFiltradas.find((impressora) => impressora.codigo === this.impressoraConfiSel.codigo);
            if (impressoraEncontrada) {
                impressoraEncontrada.grupo = this.impressoraConfiSel.grupo;
                impressoraEncontrada.impressora = this.impressoraConfiSel.impressora;
                impressoraEncontrada.imprimeDuasVias = this.impressoraConfiSel.imprimeDuasVias;
                impressoraEncontrada.modoFicha = this.impressoraConfiSel.modoFicha;
                impressoraEncontrada.usarModoTela = this.impressoraConfiSel.usarModoTela;
                impressoraEncontrada.codigo = this.impressoraConfiSel.codigo;
            }
        });
    }

    public alterarAtivoFamilia(familia: ProdutoFamiliaCheckboxViewModel) {
        const impressaoRequest: FamiliaImpressaoRequest = new FamiliaImpressaoRequest();
        impressaoRequest.codFamilia = familia.codigo;
        impressaoRequest.codigoImpressaoGrupoCab = this.impressoraConfiSel.codigo;

        if (!familia.check) {
            this.deletarFamilia(impressaoRequest);
            return;
        }

        if (this.impressoraConfiSel.codigo == 0) {
            familia.check = false;
            return;
        }

        this.impressaoService.alterarItemFamilia(impressaoRequest).subscribe((res) => {
            if (!res.success) {
                return;
            }

            this.gruposImpressoesFiltradas.forEach((impressora) => {
                impressora.dets = impressora.dets.filter((i) => i.codFamilia !== familia.codigo);
            });

            const impressoraEncontrada = this.gruposImpressoesFiltradas.find((impressora) => impressora.codigo === this.impressoraConfiSel.codigo);
            const impressaoDet: ImpressaoDet = new ImpressaoDet();

            impressaoDet.codFamilia = familia.codigo;
            impressaoDet.codigo = this.impressoraConfiSel.codigo;
            impressaoDet.codigoCab = this.impressoraConfiSel.codigoComputador;

            impressoraEncontrada.dets.push(impressaoDet);
        });
    }

    public deletarFamilia(familia: FamiliaImpressaoRequest) {
        this.impressaoService.deletarItemFamilia(familia).subscribe((res) => {
            if (!res.success) {
                return;
            }

            const impressoraEncontrada = this.gruposImpressoesFiltradas.find((impressora) => impressora.codigo === this.impressoraConfiSel.codigo);
            impressoraEncontrada.dets = impressoraEncontrada.dets.filter((impressora) => impressora.codFamilia !== familia.codFamilia);
        })
    }
}

export class ErroComputadores {
    public msg: string;
    public erro: boolean;

    constructor(
        erro: boolean,
        msg: string = '',
    ) {
        this.msg = msg;
        this.erro = erro;
    }
}